/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Stack from "../../ui/Stack";

const TreeItemChilds = ({ children, ...props }) => {
  return <Stack {...props}>{children}</Stack>;
};

export default TreeItemChilds;
